import React from "react";

import { motion } from "framer-motion";
import { useWindowSize } from "react-use";

import { styled } from "@mui/material/styles";

import { anim } from "../../utils";

import TransitionLogo from "../../../../assets/icons/TransitonLogo.svg";
import { useAnimationsEnabled } from "../../../../lib/hooks/useQueryBoard";

const transitionLogo = {
  initial: {
    opacity: 1,
  },
  animate: {
    opacity: 0,
    top: -400,
    visibility: "hidden",
    transition: { duration: 0.5, delay: 0.3, ease: [0.76, 0, 0.24, 1] },
    transitionEnd: { top: "47.5%" },
  },
  exit: {
    opacity: 1,
    visibility: "visible",
    top: "50%",
    transition: { duration: 0.4, delay: 0.2, ease: [0.33, 1, 0.68, 1] },
  },
};

const transitionCurve = (initialPath: string, targetPath: string) => {
  return {
    initial: {
      d: initialPath,
    },
    animate: {
      d: targetPath,
      transition: { duration: 0.5, delay: 0.3, ease: [0.76, 0, 0.24, 1] },
    },
    exit: {
      d: initialPath,
      transition: { duration: 0.2, ease: [0.76, 0, 0.24, 1] },
    },
  };
};

const transitionTranslate = {
  initial: {
    top: "-300px",
  },
  animate: {
    top: "-100vh",
    transition: { duration: 0.55, delay: 0.3, ease: [0.76, 0, 0.24, 1] },
    transitionEnd: {
      top: "100vh",
    },
  },
  exit: {
    top: "-300px",
    transition: { duration: 0.2, ease: [0.76, 0, 0.24, 1] },
  },
};

const MUITransitionSvg = styled(motion.svg)(({ theme }) => ({
  path: {
    fill: theme.palette.primary.main,
  },
}));

const SVG = ({ height, width }: { height: number; width: number }) => {
  const initialPath = `
        M0 300 
        Q${width / 2} 0 ${width} 300
        L${width} ${height + 300}
        Q${width / 2} ${height + 600} 0 ${height + 300}
        L0 0
      `;

  const targetPath = `
        M0 300 
        Q${width / 2} 0 ${width} 300
        L${width} ${height}
        Q${width / 2} ${height} 0 ${height}
        L0 0
    `;

  return (
    <MUITransitionSvg {...anim(transitionTranslate)} className="curve__svg">
      <motion.path {...anim(transitionCurve(initialPath, targetPath))} />
    </MUITransitionSvg>
  );
};

const Curve = React.memo<{ children: React.ReactNode }>((props) => {
  const { children } = props;

  const { width, height } = useWindowSize();

  const animationsEnabled = useAnimationsEnabled();

  if (!animationsEnabled) {
    return children;
  }

  return (
    <div className="curve">
      <div style={{ opacity: !!width ? 1 : 0 }} className="curve__background" />
      <motion.div
        // @ts-ignore
        {...anim(transitionLogo)}
        className="curve__logo"
      >
        <TransitionLogo width="30rem" />
      </motion.div>
      {!!width && <SVG width={width} height={height} />}
      {children}
    </div>
  );
});

export default Curve;
